import React, { useState } from "react";
import QuadratinoColore from "./QuadratinoColore";

function AreaInputColore(props) {
        
    //const prodottoTemp=props.prodottoTemp; 
    const colori=props.colori;
    const datoId=props.datoId;
    const inputLabel=props.inputLabel;
    const col1 = props.col1;
    const col2 = props.col2;
    const col3 = props.col3;
    const colSelChange=props.colSelChange
    const colNonSelChange=props.colNonSelChange

    const [colHover, setColHover] = useState("")

    // I quadratini si basano sull'ID: anche l'elenco dei selezionati, così mostra
    // quello che è salvato. Un testo diverso è un residuo, ed è quello che riceve Tembo.
    const selezionati = [col1, col2, col3].map((col, i) => {
        const valueId = col?.valueId
        if (valueId === undefined || valueId === null || valueId === "") return null
        const voce = colori.find(c => c["idPS" + (i + 1)] !== "" && Number(c["idPS" + (i + 1)]) === Number(valueId))
        const desc = voce?.desc ?? `ID ${valueId} non in catalogo`
        const residuo = col.valueDesc && col.valueDesc !== voce?.desc ? col.valueDesc : null
        return { desc, residuo }
    }).filter(Boolean)

    return (
        <div className="mb2 ">
            <label htmlFor={datoId}>{inputLabel}</label><br />
            <div className="mt2 measure flex flex-wrap">
                {colori.map((col,i) => <QuadratinoColore
                key={col.desc ?? i}
                colore={col}
                iDcolSel1={col1.valueId ?? ""} 
                iDcolSel2={col2.valueId ?? ""} 
                iDcolSel3={col3.valueId ?? ""} 
                colSelChange={colSelChange}
                colNonSelChange={colNonSelChange}
                setColHover={setColHover}
                />)}
            </div> 
            {/* <>componente che dice il colore su cui è il mouse al momento</> */}            
            <p>{colHover}</p>
            <h4>Selezionati</h4>
            <p>
                {selezionati.map((sel, i) => (
                    <React.Fragment key={i}>
                        {sel.desc}
                        {sel.residuo && <span className="orange"> (testo salvato diverso: {sel.residuo})</span>}
                        <br />
                    </React.Fragment>
                ))}
            </p>
        </div>
    )



}

export default AreaInputColore;